import { createMarkdownSection } from './MarkdownSection';

export const AppendixSection = createMarkdownSection(
  'appendix.md',
  {
    title: 'Appendix',
    tooltip: 'View and manage the engagement appendix for this customer',
    editingStatus: 'Editing appendix...',
    emptyTitle: 'No appendix uploaded',
    emptyDescription: 'Upload an appendix.md file to display content here',
    deleteModalTitle: 'Delete Appendix',
    deleteModalSubtitle:
      'Are you sure you want to delete the appendix file? This action cannot be undone.',
  },
  { filePrefix: 'appendix_' }
);
